
import Utils from 'assets/utils.js'
import ProjectPost from '~/components/ProjectPost.vue'
import YoutubeEmbed from '~/components/global/YoutubeEmbed.vue'
import TabLink from '~/components/global/TabLink.vue'
import ImageCarousel from '~/components/global/ImageCarousel.vue'

export default {
  components: {
    ProjectPost,
    YoutubeEmbed,
    TabLink,
    ImageCarousel
  },
  async asyncData ({ $content, params }) {
    return await Utils.defaultPostsContentFunction($content, params, 'posts/projects/technical')
  },
  data () {
    return {
      // postsPrevNext: [null, null]
    }
  }
}
